import request from '@/utils/request'
/**
 *
 * 商品管理
 *
 **/
// 查询列表接口
export const getDishPage = (params: any) => {
  return request({
    url: '/dish/page',
    method: 'get',
    params
  })
}

// 删除接口
export const deleteDish = (ids: string) => {
  return request({
    url: '/dish',
    method: 'delete',
    params: { ids }
  })
}

// 修改接口
export const editDish = (params: any) => {
  return request({
    url: '/dish',
    method: 'put',
    data: { ...params }
  })
}

// 新增接口
export const addDish = (params: any) => {
  return request({
    url: '/dish',
    method: 'post',
    data: { ...params }
  })
}

// 查询详情
export const queryDishById = (id: string | (string | null)[]) => {
  return request({
    url: `/dish/${id}`,
    method: 'get'
  })
}

// 获取商品分类列表
export const getCategoryList = (params: any) => {
  return request({
    url: '/category/list',
    method: 'get',
    params
  })
}

// 查商品列表的接口
export const queryDishList = (params: any) => {
  return request({
    url: '/dish/list',
    method: 'get',
    params
  })
}

// 文件down预览
export const commonDownload = (params: any) => {
  return request({
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    url: '/common/download',
    method: 'get',
    params
  })
}

// 上架下架---批量上架下架接口
export const dishStatusByStatus = (params: any) => {
  return request({
    url: `/dish/status/${params.status}`,
    method: 'post',
    params: { id: params.id }
  })
}

/** 设置是否参与邀请计桶 inviteBucket: 0 | 1 */
export const dishSetInviteBucket = (params: {
  id: number | string
  inviteBucket: 0 | 1
}) => {
  return request({
    url: `/dish/inviteBucket/${params.inviteBucket}`,
    method: 'post',
    params: { id: params.id }
  })
}

/** 商品排序上下移 direction: up | down */
export const dishMoveSort = (params: { id: number | string; direction: 'up' | 'down' }) => {
  return request({
    url: `/dish/sort/${params.direction}`,
    method: 'post',
    params: { id: params.id }
  })
}

/** 直接设置商品在指定展示分类下的排序值（越小越靠前） */
export const dishSetSort = (params: {
  id: number | string
  categoryId: number | string
  sort: number
}) => {
  return request({
    url: `/dish/sort`,
    method: 'post',
    params: {
      id: params.id,
      categoryId: params.categoryId,
      sort: params.sort
    }
  })
}

//商品分类数据查询
export const dishCategoryList = (params: any) => {
  return request({
    url: `/category/list`,
    method: 'get',
    params: { ...params }
  })
}
